export default {
    facultyUniversityTypes: [],
    brancheTypes: [],
    startupPhaseTypes: [],
    countryTypes: [],
    casequalityTypes: [],
    affirmationTypes: [],
    universityTypes: [],
    rechtsformTypes: [],
    languagesTypes: [],
    educationTypes: [],
    cantonTypes: [],
    salutationTypes: [],
    priovlabTypes: [],
    priovlabxmasTypes: [],
    profilcategoryTypes: [],
    vkCaseStatusTypes: [],
    investmentTypes: [],
    investmentStages: [],
    profileStatus: [],
    typeofOrganization: [],
    roles: [],
    vekmisTechnology: [],
    addressInterests: [],
    awards: [],
    sectors: [],
    reportingGroups: [],
    eventSignupFunctions: [],
    eventStartupStages: [],
    eventStartupSectors: [],
    eventIndustryExperiences: [],
    eventRelationshipUnis: [],
    eventEmploymentStatus: []
  }
